import { Box, BoxProps, Button, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import { FC, Fragment } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { TransNextLink } from '@/components/ui/shared/links/TransNextLink/TransNextLink';
import { useAnalytics } from '@/context/Analytics';
import { ThinSubject } from '@/resources/ThinSubject';

interface ILectureCountProps extends BoxProps {
  subject?: ThinSubject;
  count?: number;
  href: string;
}

export const LectureHeaderDesktopAction: FC<ILectureCountProps> = ({ subject, count, href, ...rest }) => {
  const formatedTotalCount = count?.toLocaleString('en-US');
  const analytics = useAnalytics();

  return (
    <Box {...rest}>
      <Trans
        i18nKey="library.subject.viewLectureCount"
        values={{ totalCount: formatedTotalCount }}
        components={{
          hyperlink: (
            <TransNextLink
              href={href}
              onClick={() =>
                analytics.track('library_landing_view_all', {
                  subject_name: subject?.name,
                  subject_id: subject?.id,
                })
              }
            />
          ),
          span: <Text as="span" color="violet.500" fontWeight="bold" />,
        }}
      />
    </Box>
  );
};

export const LectureHeaderMobileAction: FC<ILectureCountProps> = ({ subject, href, ...rest }) => {
  const { t } = useTranslation();
  const analytics = useAnalytics();

  return (
    <Box {...rest}>
      <NextLink passHref href={href} legacyBehavior>
        <Button
          as="a"
          height="32px"
          variant="ghost"
          textTransform="uppercase"
          onClick={() =>
            analytics.track('library_landing_view_all', {
              subject_name: subject?.name,
              subject_id: subject?.id,
            })
          }
        >
          {t('common.seeAll')}
        </Button>
      </NextLink>
    </Box>
  );
};

export const LectureGroupAction: FC<ILectureCountProps> = ({ count, subject, ...rest }) => {
  return (
    <Fragment>
      <LectureHeaderDesktopAction
        display={{ base: 'none', lg: 'inline-block' }}
        subject={subject}
        count={count}
        {...rest}
      />
      <LectureHeaderMobileAction display={{ base: 'inline-block', lg: 'none' }} subject={subject} {...rest} />
    </Fragment>
  );
};
